// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34tPU","expireSoon":"styles_expireSoon__c3l0G"};